<app-shared-dialog
  [title]="'quotations_and_orders.filter.title' | translate"
  [options]="{
    titleIcon: 'filter_icon',
    cancelText: 'common.cancel' | translate,
    cancelButtonStyle: 'secondary-btn',
    middleText: 'filter.reset_filters' | translate,
    middleIcon: 'rollback',
    middleButtonStyle: 'secondary-btn',
    confirmText: 'common.apply' | translate,
    confirmButtonStyle: 'primary',
    size: 'large'
  }"
  (cancel)="close()"
  (middle)="resetFilters()"
  (confirm)="apply()"
>
  <div class="filter-form">
    <!-- Row 1: Name (full width) -->
    <div class="filter-row">
      <div class="standard-input">
        <label>{{ 'quotations_and_orders.filter.fields.name' | translate }}</label>
        <input
          type="text"
          [(ngModel)]="filter.quotationInfoFilter.id_order"
          [placeholder]="'quotations_and_orders.filter.fields.name_placeholder' | translate"
        />
      </div>
    </div>

    <!-- Row 2: Source + Catalog -->
    <div class="filter-row">
      <div class="standard-input">
        <label>{{ 'quotations_and_orders.source' | translate }}</label>
        <select [(ngModel)]="filter.quotationInfoFilter.channel">
          <option [ngValue]="undefined" disabled>{{ 'quotations_and_orders.source' | translate }}</option>
          <option *ngFor="let opt of sourceOptions" [value]="opt.value">{{ opt.label | translate }}</option>
        </select>
      </div>
      <div class="standard-input">
        <label>{{ 'quotations_and_orders.filter.fields.status' | translate }}</label>
        <select [(ngModel)]="filter.quotationInfoFilter.status">
          <option [ngValue]="undefined" disabled>{{ 'quotations_and_orders.filter.fields.status' | translate }}</option>
          <option value="sale">{{ 'quotations_and_orders.QuotationStatus.sale' | translate }}</option>
          <option value="declined">{{ 'quotations_and_orders.QuotationStatus.declined' | translate }}</option>
          <option value="cancel">{{ 'quotations_and_orders.QuotationStatus.cancel' | translate }}</option>
          <option value="requested">{{ 'quotations_and_orders.QuotationStatus.requested' | translate }}</option>
          <option value="draft">{{ 'quotations_and_orders.QuotationStatus.draft' | translate }}</option>
          <option value="to_be_validated">{{ 'quotations_and_orders.QuotationStatus.to_be_validated' | translate }}</option>
          <option value="pending_inventory">{{ 'quotations_and_orders.QuotationStatus.pending_inventory' | translate }}</option>
          <option value="sent">{{ 'quotations_and_orders.QuotationStatus.sent' | translate }}</option>
          <option value="done">{{ 'quotations_and_orders.QuotationStatus.done' | translate }}</option>
        </select>
      </div>
    </div>

    <!-- Row 3: ERP ID + Volta ID -->
    <div class="filter-row">
      <div class="standard-input">
        <label>{{ 'quotations_and_orders.list_quotations.erp_id' | translate }}</label>
        <input
          type="text"
          [(ngModel)]="filter.quotationInfoFilter.external_id"
          [placeholder]="'common.type' | translate"
        />
      </div>
      <div class="standard-input">
        <label>{{ 'quotations_and_orders.filter.fields.volta_id' | translate }}</label>
        <input
          type="text"
          [(ngModel)]="filter.quotationInfoFilter.order_id"
          [placeholder]="'common.type' | translate"
        />
      </div>
    </div>

    <div class="filter-row">
      <div class="standard-input">
        <label>{{ 'companies.customer_po_number' | translate }}</label>
        <input
          type="text"
          [(ngModel)]="filter.quotationInfoFilter.buyer_po"
          [placeholder]="'common.type' | translate"
        />
      </div>
      <div class="standard-input">
        <label>{{ 'Catalogs.catalog_name' | translate }}</label>
        <input
          type="text"
          [formControl]="catalogSearchCtrl"
          [matAutocomplete]="catalogAuto"
          [placeholder]="'Catalogs.catalog_name' | translate"
        />
        <mat-autocomplete #catalogAuto="matAutocomplete">
          <mat-option
            *ngFor="let catalog of filteredCatalogs$ | async"
            [value]="catalog.name"
            (onSelectionChange)="selectCatalog(catalog)"
          >
            {{ catalog.name }}
          </mat-option>
        </mat-autocomplete>
      </div>
    </div>

    <!-- Contains product(s) (autocomplete multi-chip) -->
    <div class="filter-row">
      <div class="standard-input filter-skus">
        <label>{{ 'quotations_and_orders.filter.fields.contains_products' | translate }}</label>
        <mat-chip-list #nameChipList>
          <mat-chip
            *ngFor="let product of filter.quotationInfoFilter.products"
            [selectable]="true"
            [removable]="true"
            (removed)="removeProduct(product)"
          >
            {{ product.name }}
            <mat-icon matChipRemove>cancel</mat-icon>
          </mat-chip>
          <input
            #nameInput
            [formControl]="productNameSearchInput"
            [placeholder]="'quotations_and_orders.filter.fields.contains_products_placeholder' | translate"
            [matChipInputFor]="nameChipList"
            [matChipInputSeparatorKeyCodes]="separatorKeysCodes"
            [matChipInputAddOnBlur]="false"
            [matAutocomplete]="nameAuto"
            (matChipInputTokenEnd)="addProduct($event)"
            (blur)="onProductBlur()"
          />
        </mat-chip-list>
        <mat-autocomplete #nameAuto="matAutocomplete" (optionSelected)="onProductOptionSelected($event)">
          <mat-option *ngFor="let product of productOptions$ | async" [value]="product">
            {{ product.name }}<span *ngIf="product | productCode:''" class="user-opt-email"> — {{ product | productCode }}</span>
          </mat-option>
        </mat-autocomplete>
        <span class="user-search-hint" *ngIf="productNameSearchLoading">{{ 'common.loading' | translate }}</span>
      </div>
    </div>

    <!-- Scope injected by "View all orders" on a company page. Read-only: removable, not addable. -->
    <div class="filter-row" *ngIf="(filter.organizeFilter.locations || []).length">
      <div class="standard-input">
        <label>{{ 'quotations_and_orders.filter.fields.locations' | translate }}</label>
        <mat-chip-list>
          <mat-chip
            *ngFor="let location of filter.organizeFilter.locations"
            [selectable]="false"
            [removable]="true"
            (removed)="removeLocation(location)"
          >
            {{ location.name }}
            <mat-icon matChipRemove>cancel</mat-icon>
          </mat-chip>
        </mat-chip-list>
      </div>
    </div>

    <div class="filter-row" *ngIf="filter.ownershipFilter && !isOwnershipScopeForced">
      <div class="standard-input user-search-field">
        <label for="q_filter_owner">{{ 'quotations_and_orders.orders_filter.fields.filter_owner' | translate }}</label>
        <div class="user-search-row">
          <input
            id="q_filter_owner"
            type="text"
            [formControl]="ownerSearchInput"
            [matAutocomplete]="qOwnerAuto"
            [placeholder]="'quotations_and_orders.orders_filter.fields.user_search_placeholder' | translate"
          />
          <button
            type="button"
            class="user-search-clear"
            *ngIf="filter.ownershipFilter.owner"
            (click)="clearOwnerFilter()"
          >
            ×
          </button>
        </div>
        <mat-autocomplete #qOwnerAuto="matAutocomplete" (optionSelected)="onOwnerSelected($event)">
          <mat-option *ngFor="let u of ownerOptions" [value]="u">
            {{ u.name }}<span *ngIf="u.email" class="user-opt-email"> — {{ u.email }}</span>
          </mat-option>
        </mat-autocomplete>
        <span class="user-search-hint" *ngIf="ownerSearchLoading">{{ 'common.loading' | translate }}</span>
      </div>
      <div class="standard-input user-search-field">
        <label for="q_filter_creator">{{ 'quotations_and_orders.orders_filter.fields.filter_creator' | translate }}</label>
        <div class="user-search-row">
          <input
            id="q_filter_creator"
            type="text"
            [formControl]="creatorSearchInput"
            [matAutocomplete]="qCreatorAuto"
            [placeholder]="'quotations_and_orders.orders_filter.fields.user_search_placeholder' | translate"
          />
          <button
            type="button"
            class="user-search-clear"
            *ngIf="filter.ownershipFilter.creator"
            (click)="clearCreatorFilter()"
          >
            ×
          </button>
        </div>
        <mat-autocomplete #qCreatorAuto="matAutocomplete" (optionSelected)="onCreatorSelected($event)">
          <mat-option *ngFor="let u of creatorOptions" [value]="u">
            {{ u.name }}<span *ngIf="u.email" class="user-opt-email"> — {{ u.email }}</span>
          </mat-option>
        </mat-autocomplete>
        <span class="user-search-hint" *ngIf="creatorSearchLoading">{{ 'common.loading' | translate }}</span>
      </div>
      <!--
        Inside the same row as owner and creator, so it inherits the `!isOwnershipScopeForced`
        guard: for an own_data user the backend already narrows to their own orders, and a team
        picker there could only ever narrow further while looking like it does more.
      -->
      <div class="standard-input filter-chip-field">
        <label for="q_filter_team">{{ 'quotations_and_orders.orders_filter.fields.filter_team' | translate }}</label>
        <!-- No matChipInputTokenEnd on purpose: a team needs an id, so free text must
             never create one. -->
        <mat-chip-list #qTeamChipList>
          <mat-chip
            *ngFor="let team of filter.ownershipFilter.teams"
            [selectable]="false"
            [removable]="true"
            (removed)="removeTeam(team)"
          >
            {{ team.name }}
            <mat-icon matChipRemove>cancel</mat-icon>
          </mat-chip>
          <input
            id="q_filter_team"
            [formControl]="teamSearchCtrl"
            [placeholder]="'quotations_and_orders.orders_filter.fields.team_search_placeholder' | translate"
            [matChipInputFor]="qTeamChipList"
            [matChipInputAddOnBlur]="false"
            [matAutocomplete]="qTeamAuto"
          />
        </mat-chip-list>
        <!-- (optionSelected) on the autocomplete, NOT (onSelectionChange) on the option:
             the latter also fires when Material DESELECTS an option, so a multiselect
             picker would re-run the handler for a team the user is de-picking. More
             load-bearing here than it was for the single-select version, not less.
             Same pattern as the owner and creator pickers above. -->
        <mat-autocomplete #qTeamAuto="matAutocomplete" (optionSelected)="onTeamSelected($event)">
          <mat-option *ngFor="let team of filteredTeams$ | async" [value]="team">
            {{ team.name }}
          </mat-option>
        </mat-autocomplete>
      </div>
    </div>

    <!-- Row 4: Creation Date from-to + Last Update -->
    <div class="filter-row">
      <div class="standard-input filter-dates">
        <label>{{ 'quotations_and_orders.filter.fields.creation_date' | translate }}</label>
        <div class="date-range">
          <input
            type="date"
            [(ngModel)]="filter.quotationInfoFilter.from_date"
            [placeholder]="'common.from' | translate"
          />
          <input
            type="date"
            [(ngModel)]="filter.quotationInfoFilter.to_date"
            [placeholder]="'common.to' | translate"
          />
        </div>
      </div>
      <div class="standard-input">
        <label>{{ 'quotations_and_orders.filter.fields.last_update_date' | translate }}</label>
        <input
          type="date"
          [(ngModel)]="filter.quotationInfoFilter.latest_event_date"
        />
      </div>
    </div>

    <!-- Row 5: Order Total Amount (min/max) + Total SKU Quantity (min/max) -->
    <div class="filter-row">
      <div class="standard-input">
        <label>{{ 'quotations_and_orders.filter.fields.order_total_amount' | translate }}</label>
        <div class="min-max-row">
          <input
            type="number"
            min="0"
            [(ngModel)]="filter.extraInfoFilter.total_price_min"
            [placeholder]="'common.min' | translate"
          />
          <input
            type="number"
            min="0"
            [(ngModel)]="filter.extraInfoFilter.total_price_max"
            [placeholder]="'common.max' | translate"
          />
        </div>
      </div>
      <div class="standard-input">
        <label>{{ 'quotations_and_orders.filter.fields.total_sku_quantity' | translate }}</label>
        <div class="min-max-row">
          <input
            type="number"
            min="0"
            [(ngModel)]="filter.extraInfoFilter.total_sku_min"
            [placeholder]="'common.min' | translate"
          />
          <input
            type="number"
            min="0"
            [(ngModel)]="filter.extraInfoFilter.total_sku_max"
            [placeholder]="'common.max' | translate"
          />
        </div>
      </div>
    </div>
    <!-- Line-composition ranges (WB-8066): counts that include unmatched lines. -->
    <div class="filter-row">
      <div class="standard-input">
        <label>{{ 'quotations_and_orders.filter.fields.total_lines' | translate }}</label>
        <div class="min-max-row">
          <input
            type="number"
            min="0"
            [(ngModel)]="filter.extraInfoFilter.total_lines_min"
            [placeholder]="'common.min' | translate"
          />
          <input
            type="number"
            min="0"
            [(ngModel)]="filter.extraInfoFilter.total_lines_max"
            [placeholder]="'common.max' | translate"
          />
        </div>
      </div>
      <div class="standard-input">
        <label>{{ 'quotations_and_orders.filter.fields.lines_needing_review' | translate }}</label>
        <div class="min-max-row">
          <input
            type="number"
            min="0"
            [(ngModel)]="filter.extraInfoFilter.lines_needing_review_min"
            [placeholder]="'common.min' | translate"
          />
          <input
            type="number"
            min="0"
            [(ngModel)]="filter.extraInfoFilter.lines_needing_review_max"
            [placeholder]="'common.max' | translate"
          />
        </div>
      </div>
    </div>
    <div class="filter-row">
      <div class="standard-input">
        <label>{{ 'quotations_and_orders.filter.fields.unmatched_lines' | translate }}</label>
        <div class="min-max-row">
          <input
            type="number"
            min="0"
            [(ngModel)]="filter.extraInfoFilter.unmatched_lines_min"
            [placeholder]="'common.min' | translate"
          />
          <input
            type="number"
            min="0"
            [(ngModel)]="filter.extraInfoFilter.unmatched_lines_max"
            [placeholder]="'common.max' | translate"
          />
        </div>
      </div>
    </div>
    <!-- Show duplicates only -->
    <div class="filter-row">
      <div class="standard-input">
        <label class="dup-filter-checkbox">
          <input
            type="checkbox"
            [(ngModel)]="filter.quotationInfoFilter.has_duplicates"
            [ngModelOptions]="{ standalone: true }"
          />
          <span class="dup-filter-checkbox__ui">
            <span class="dup-filter-checkbox__mark" aria-hidden="true"></span>
            <span class="dup-filter-checkbox__text">{{
              'quotations_and_orders.filter.fields.show_duplicates_only' | translate
            }}</span>
          </span>
        </label>
      </div>
    </div>
  </div>
</app-shared-dialog>
